export default {
  result: state => state.resultMatchesLogs,
  lastUpdateTimestamp: state => state.lastUpdateTimestamp,
};
